"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import { workScopeStatusOptions } from "../../constants/options"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import WorkScopeStatusSelect from "../work-scope-status-select"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const BASE_FIELD_NAME = "home.stuccoInfo"

function HomeStuccoForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillStuccoOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillStuccoOn` })
    
    // Watch status field and claimed by field
    const stucco = useWatch({ control, name: `${BASE_FIELD_NAME}.stucco` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillStucco = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillStucco` })
    const goodwillStuccoClaimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillStuccoClaimedBy` })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: stucco,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillStucco,
        claimedBy: goodwillStuccoClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillStuccoClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillStuccoOn,
    })

    return (
        <HomeDetailsWrapperAccordion 
            heading="Rendering/Stucco"
            wrapperClassName="xl:grid-cols-2"
        >
            <WorkScopeStatusSelect workScopeSlug="stucco"
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Rendering/Stucco" toggleName={`${BASE_FIELD_NAME}.goodwillStuccoOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.stucco`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillStuccoOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Rendering/Stucco Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillStucco`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Rendering/Stucco Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillStuccoClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Add any other detail you can about the Rendering/Stucco needs",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={4}
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeStuccoForm

